import MovableFixedBlock from "./containers/MovableFixedBlock";
export default MovableFixedBlock;